module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAcCAYAAABYvS47AAAABGdBTUEAALGPC/xhBQAAAT5JREFUOBHVkjFOhUAQhtnloaUJiQ0HoDCeQft3AKKNvSQUVM/KRI2lCVzhdXADWxMb4wWgsBMqGytjDPj/sIvrwgXeJjuz88+3w+yywlGjLMu9pmlu+76/oCSE2AZBcB1F0TfjFQ2HgjZj5DjYsIHG8IpG0nDoSmM0WlObQBNYWk8ge7IBUxN5nh/jE3dhGJ7VdX2jP6cP07btObSDFUyBeVRV1WWapmx8aJ7VWaTruhybepFlWQcQawHXP8G/qxYO4U+g7TNmRcGF8qfwDGdjOswsYwk7AfJarL5nIRmJ6xieyCxrCGQkxqOhLS7JSM/z7lH6c5GAyBwZGcfxm+u6awgfNkyNOTLDhSdJ8gzo1QapqdzfC1+A/kk78Qt1x7j9H73W3tSmw+DOXjSgvalNoO/7D0gUmF9qFtT0pl+7j4kcIu1h0wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/child.png
// module id = 938
// module chunks = 0